/**
 * Right-panel tab ids for the positions feature. Shared between the manifest
 * (which registers the panel views) and the center views (which open/focus a tab
 * via `useLayoutStore`). Keep in sync with `manifest.ts`.
 *
 * The DIRECT-skill link panel reuses the skill-groups feature's `SKILL_LINK_TAB`
 * + `AdminSkillLinkView` + `useSkillLinkPanelStore` — a position direct link has
 * the exact same shape (`{ skillKey, skillGridKey, weight }`). Only the
 * group-link panel is specific to positions.
 */

export { SKILL_LINK_TAB } from '../skill-groups/skillGroupPanels';

/** "Link an existing skill group" form (group + weight). Edit only. */
export const SKILL_GROUP_LINK_TAB = 'position-skill-group-link';
